import { useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { useToast } from "@/components/ui/use-toast";
import StaffAccountForm from "@/components/onboarding/StaffAccountForm";

const StaffOnboarding = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get("companyId");
  const prefilledEmail = searchParams.get("email") ?? "";
  const role = (searchParams.get("role") ?? "user") as "user" | "admin";

  const handleStaffAccountCreation = async (userId: string) => {
    toast({
      title: "帳號創建成功",
      description: "您的帳號已成功創建，正在跳轉到登入頁面",
    });

    // Redirect to auth page after successful account creation
    setTimeout(() => {
      navigate("/auth");
    }, 1500);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <Card className="w-full max-w-md">
        <CardContent className="p-6">
          <div className="mb-6 text-center">
            <h1 className="text-2xl font-bold mb-2">完成帳號設定</h1>
            <p className="text-muted-foreground">
              請設定您的用戶名和密碼以完成註冊
            </p>
          </div>
          
          <div className="space-y-6">
            <StaffAccountForm
              onComplete={handleStaffAccountCreation}
              companyId={companyId}
              email={prefilledEmail}
              role={role}
            />
            
            <div className="flex flex-col gap-2 pt-4">
              <Link
                to="/auth"
                className="text-center text-sm text-gray-500 hover:text-primary"
              >
                返回登入頁面
              </Link>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default StaffOnboarding;